//router
import CryptoJS from 'crypto-js'
import { createRouter, createWebHistory } from 'vue-router'

// childrens

import ActiveClinicalCases from '@/features/activeClinicalCases'
import AdmClinicalCases from '@/features/admClinicalCases'
import AllocationClinicalCases from '@/features/allocationClinicalCases'
// import AuthorizedDistributeClinicalCases from '@/features/authorizedDistributeClinicalCases'
import ClinicalCaseConsultation from '@/features/clinicalCaseConsultation'
import ClinicalCaseConsultationManager from '@/features/clinicalCaseConsultationManager'
import ClinicalCaseConsultationRepresentant from '@/features/clinicalCaseConsultationRepresentant'
import ClinicalCasesConsultationDoctor from '@/features/clinicalCasesConsultationDoctor'
import ClinicalCasesEvaluation from '@/features/clinicalCasesEvaluation'
import ClinicalCasesIndustry from '@/features/clinicalCasesIndustry'
import ConsultantDoctorInvitation from '@/features/consultantDoctorInvitation'
import ConsultantMedicalRegistration from '@/features/consultantMedicalRegistration'
import ConsultationClinicalCases from '@/features/consultationClinicalCases'
import ContractClinicalCases from '@/features/contractClinicalCases'
import DocumentDownload from '@/features/documentsDownload'
import DocumentUpload from '@/features/documentsManagement'
import DocumentType from '@/features/documentsType'
import Home from '@/features/home/index.vue'
import Illnesses from '@/features/illnesses'
import Industries from '@/features/industries'
//import IndustryRegistration from '@/features/industryRegistration'
// rotas
import IndustryRepresentantMan from '@/features/industryRepresentantMan'
import Login from '@/features/login'
import LoginClientDoctor from '@/features/loginClientDoctor'
import ManagerRegistration from '@/features/managerRegistration'
import Registration from '@/features/registration'
import RegistrationClinicalCases from '@/features/registrationClinicalCases'
import RegistrationAway from '@/features/registrationConsultantDoctorAway'
import RepresentativeRegistration from '@/features/representativeRegistration'
import Specialties from '@/features/specialties'
import UpdateClinicalCase from '@/features/updateClinicalCase'
// import Tests from '@/features/test/index.vue'
import store from '@/store'
import Layout from '@/views/layout'

const isRegistred = () => store?.getters['user/isRegistred']

const routes = [
  {
    path: '/',
    name: '',
    component: Layout,
    children: [
      // {
      //   path: '/teste-de-apis',
      //   name: 'Testes',
      //   component: Tests,
      //   meta: {
      //     title: 'Testes de apis'
      //   }
      // },
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          title: 'Início'
        }
      },
      {
        path: '/update-clinical-case',
        name: 'UpdateClinicalCase',
        component: UpdateClinicalCase,
        meta: {
          title: 'Atualizar Contrato Caso Clínico'
        }
      },
      {
        path: '/registration-away/:encryptedData',
        name: 'RegistrationAway',
        component: RegistrationAway,
        props: true,
        meta: {
          requiresAuth: false,
          title: 'Registro de Médico Solicitante'
        },
        beforeEnter: (to, from, next) => {
          try {
            const decryptedBytes = CryptoJS.AES.decrypt(
              decodeURIComponent(to.params.encryptedData),
              'chave_secreta'
            )
            const decryptedData = JSON.parse(
              decryptedBytes.toString(CryptoJS.enc.Utf8)
            )

            to.params.contractId = decryptedData.selectContract
            to.params.contractId2 = decryptedData.contractId
            to.params.contractName = decryptedData.contractName

            next()
          } catch (error) {
            console.error('Erro ao decriptografar dados na rota:', error)
            next('/error') // Redireciona para uma página de erro
          }
        }
      },
      // {
      //   path: '/induster',
      //   name: 'IndustryRegistration',
      //   component: IndustryRegistration,
      //   meta: {
      //     title: 'Cadastro Indústria'
      //   }
      // },
      {
        path: '/doc-download',
        name: 'Consulta a Documentação',
        component: DocumentDownload,
        meta: {
          title: 'Consulta a Documentação'
        }
      },
      {
        path: '/doc-download',
        name: 'Documentação de Apoio',
        component: DocumentDownload,
        meta: {
          title: 'Documentação de Apoio'
        }
      },
      {
        path: '/doc-type',
        name: 'Tipos de Documento',
        component: DocumentType,
        meta: {
          title: 'Tipos de Documento'
        }
      },
      {
        path: '/doc-upload',
        name: 'Registro de Documentação',
        component: DocumentUpload,
        meta: {
          title: 'Registro de Documentação'
        }
      },
      {
        path: '/registration-clinical-cases',
        name: 'Registro de Contrato e Geração de Casos Clínicos',
        component: RegistrationClinicalCases,
        meta: {
          title: 'Registro de Contrato e Geração de Casos Clínicos'
        }
      },
      {
        path: '/consultation-clinical-contracts',
        name: 'ConsultationClinicalCases',
        component: ConsultationClinicalCases,
        meta: {
          title: 'Consulta Contratos Casos Clínicos'
        }
      },
      {
        path: '/consultant-doctor',
        name: 'ConsultantDoctorInvitation',
        component: ConsultantDoctorInvitation,
        meta: {
          title: 'Geração de Convite para Médico Consultor'
        }
      },
      {
        path: '/industry-representant-management',
        name: 'IndustryRepresentantMan',
        component: IndustryRepresentantMan,
        meta: {
          title: 'Gestão de Gestores/Consultores da Indústria'
        }
      },
      {
        path: '/medical-registration',
        name: 'ConsultantMedicalRegistration',
        component: ConsultantMedicalRegistration,
        meta: {
          title: isRegistred ? 'Atualização de Dados Cadastrais' : 'Cadastro'
        }
      },
      {
        path: '/registration',
        name: 'Registration',
        component: Registration,
        meta: {
          title: isRegistred ? 'Atualização de Dados Cadastrais' : 'Cadastro'
        }
      },
      {
        path: '/adm-clinical-cases',
        name: 'AdmClinicalCases',
        component: AdmClinicalCases,
        meta: {
          title: 'Administração de Casos Clínicos Designados'
        }
      },
      {
        path: '/allocation-clinical-cases',
        name: 'AllocationClinicalCases',
        component: AllocationClinicalCases,
        meta: {
          title: 'Atribuição de Casos Clínicos'
        }
      },
      {
        path: '/representative-registration',
        name: 'RepresentativeRegistration',
        component: RepresentativeRegistration,
        meta: {
          title: isRegistred ? 'Atualização de Dados Cadastrais' : 'Cadastro'
        }
      },
      {
        path: '/manager-registration',
        name: 'ManagerRegistration',
        component: ManagerRegistration,
        meta: {
          title: isRegistred ? 'Atualização de Dados Cadastrais' : 'Cadastro'
        }
      },
      {
        path: '/clinical-cases-evaluation',
        name: 'clinicalCasesEvaluation',
        component: ClinicalCasesEvaluation,
        meta: {
          title: 'Casos Clínicos Designados'
        }
      },
      {
        path: '/clinical-cases-industry',
        name: 'clinicalCasesIndustry',
        component: ClinicalCasesIndustry,
        meta: {
          title: 'Casos Clínicos Designados'
        }
      },
      {
        path: '/clinical-cases-consultation-doctor',
        name: 'clinicalCasesConsultationDoctor',
        component: ClinicalCasesConsultationDoctor,
        meta: {
          title: 'Avaliação de Casos Clínicos Designados'
        }
      },
      {
        path: '/active-clinical-case',
        name: 'activeClinicalCase',
        component: ActiveClinicalCases,
        meta: {
          title: 'Ativação de Caso Clínico',
          loading: true
        },
        beforeEnter: (to, from, next) => {
          if (to.meta.loading) {
            store.commit[
              ('clinicalCasesEvaluation/setLoadingActiveVoucher', true)
            ]
            setTimeout(() => {
              store.commit[
                ('clinicalCasesEvaluation/setLoadingActiveVoucher', false)
              ]

              next()
            }, 1000)
          } else {
            next()
          }
        }
      },
      {
        path: '/specialties',
        name: 'Specialties',
        component: Specialties,
        meta: {
          title: 'Gestão de Especialidades'
        }
      },
      {
        path: '/illnesses',
        name: 'Illnesses',
        component: Illnesses,
        meta: {
          title: 'Gestão de Doenças'
        }
      },
      {
        path: '/industries',
        name: 'Industries',
        component: Industries,
        meta: {
          title: 'Gestão de Patrocinadores'
        }
      },
      {
        path: '/contract-clinical-case',
        name: 'ContractClinicalCases',
        component: ContractClinicalCases,
        meta: {
          title: 'Gestão Médicos Consultores'
        }
      },
      {
        path: '/clinical-case-consultation',
        name: 'ClinicalCaseConsultation',
        component: ClinicalCaseConsultation,
        meta: {
          title: 'Consulta Status Casos Clínicos'
        }
      },
      {
        path: '/clinical-case-consultation-representant',
        name: 'ClinicalCaseConsultationRepresentant',
        component: ClinicalCaseConsultationRepresentant,
        meta: {
          title: 'Consulta Status Casos Clínicos'
        }
      },
      {
        path: '/clinical-case-consultation-manager',
        name: 'ClinicalCaseConsultationManager',
        component: ClinicalCaseConsultationManager,
        meta: {
          title: 'Consulta Casos Clínicos Ativos'
        }
      }
      // {
      //   path: '/authorized-distribute-clinical-cases',
      //   name: 'AuthorizedDistributeClinicalCases',
      //   component: AuthorizedDistributeClinicalCases,
      //   meta: {
      //     title: 'Registro de Pessoas Autorizadas a Distribuir Casos Clínicos'
      //   }
      // }
    ],
    beforeEnter: (to, from, next) => {
      if (to.meta.requiresAuth === false) {
        next()
      } else if (!store.getters.isLoggedIn) {
        next('/login')
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters.isLoggedIn) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/login-client-doctor',
    name: 'Médico Solicitante - Login',
    component: LoginClientDoctor,
    props: (route) => ({
      activetoken: route.query.activetoken || null
    }),
    beforeEnter: (to, from, next) => {
      if (store.getters.isLoggedIn) {
        next('/login-client-doctor')
      } else if (to.query.activetoken) {
        next()
      } else {
        next()
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_PATH),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  }
})

// Update the document title on each navigation
router.beforeEach((to, from, next) => {
  const isLoginPage = to.path === '/login'
  const requiresAuth = to.matched.some(
    (record) => record.meta.requiresAuth !== false
  )

  if (!isLoginPage && requiresAuth) {
    const userType = store.getters['user/getRole']

    switch (userType) {
      case 'consultant_doctor':
        if (!store.getters['user/isRegistred']) {
          next('/medical-registration')
        }
        break

      case 'client_doctor':
        if (!store.getters['user/isRegistred']) {
          next('/registration')
        }
        break

      case 'agent':
        if (!store.getters['user/isRegistred']) {
          next('/representative-registration')
        }
        break
      case 'agent_manager':
        if (!store.getters['user/isRegistred']) {
          next('/manager-registration')
        }
        break
      default:
        break
    }
  }

  const baseTitle = 'Medical Second Opinion'

  if (to.meta && to.meta.title) {
    document.title = `${baseTitle} | ${to.meta.title}`
  } else {
    document.title = baseTitle
  }

  next()
})

export default router
